import { render, staticRenderFns } from "./UserEvaluationModal.vue?vue&type=template&id=c979cca0&scoped=true"
import script from "./UserEvaluationModal.vue?vue&type=script&lang=js"
export * from "./UserEvaluationModal.vue?vue&type=script&lang=js"
import style0 from "./UserEvaluationModal.vue?vue&type=style&index=0&id=c979cca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c979cca0",
  null
  
)

export default component.exports